<template>
  <div class="custom-form-select cursor-pointer">
    <div
      class="custom-form-select__selected closed"
      @click="showOptions = !showOptions"
    >
      <p>{{ selectedDeativatedType }}</p>
      <span>
        <svg
          data-v-17902353=""
          width="14"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-v-17902353=""
            d="M1 1.03467L5 5.03467L9 1.03467"
            stroke="#FCC210"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </span>
    </div>
    <transition name="select-options">
      <div class="custom-form-select__options" v-if="showOptions">
        <div
          :class="{ active: selectedDeativatedType == 'Deactivated Users' }"
          @click="selectOption('Deactivated Users')"
          class="custom-form-select__option"
        >
          <p>Deactivated Users ({{usercount}})</p>
        </div>
        <div
          class="custom-form-select__option"
          :class="{ active: selectedDeativatedType == 'Deactivated Groups' }"
          @click="selectOption('Deactivated Groups')"
        >
          <p>Deactivated Groups ({{groupcount}})</p>
        </div>
        
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['usercount', 'groupcount'],
  data() {
    return {
      selectedDeativatedType: "Deactivated Users",
      showOptions: false,
    };
  },
  methods: {
    selectOption(option) {
      this.selectedDeativatedType = option;
      this.showOptions = false;
      this.$emit("change-deactivated-type", this.selectedDeativatedType);
    },
  },
};
</script>

<style scoped>
.custom-form-select__selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0.5px solid #FCC210;
  border-radius: 4px;
  padding: 0.45rem 0.75rem;
  width: 16rem;
}
.custom-form-select__options {
  position: absolute;
  width: 16rem;
  background-color: #ffffff;
  z-index: 999;
  /* border: 0.5px solid #FCC210; */
  box-shadow:  0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  padding: 0.45rem 1rem;
  margin-top: 1rem;
}
.custom-form-select__option {
  padding: 0.5rem 0.5rem;
}
.custom-form-select__option.active {
  background: #FCC210;
  border-radius: 3px;
}
.select-options-enter,
.select-options-leave-to {
  opacity: 0;
  transform: translateY(-20%);
}
.select-options-enter-to,
.select-options-leave {
  opacity: 1;
  transform: translateY(0);
}
.select-options-enter-active,
.select-options-leave-active {
  transition: all ease 0.4s;
}
@media screen and (max-width: 768px) {
  .custom-form-select__selected {
    width: 100%;
  }
}
</style>
